var map = {
	"./en": "87U4",
	"./en/": "87U4",
	"./en/faq.html": "WKYQ",
	"./en/index": "87U4",
	"./en/index.js": "87U4",
	"./en/privacy.html": "xdRf",
	"./en/terms.html": "Mj/6",
	"./jp": "jAup",
	"./jp/": "jAup",
	"./jp/faq.html": "0YUq",
	"./jp/index": "jAup",
	"./jp/index.js": "jAup",
	"./jp/privacy.html": "BACU",
	"./jp/terms.html": "gWHQ",
	"./zh": "VBxI",
	"./zh/": "VBxI",
	"./zh/faq.html": "siug",
	"./zh/index": "VBxI",
	"./zh/index.js": "VBxI",
	"./zh/privacy.html": "WZVZ",
	"./zh/terms.html": "e21R"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ay+2";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales ^\.\/.*$
// module id = ay+2
// module chunks = 1